import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Loading } from 'e4shared';
import TaskIcon from 'views/user/task/components/taskIcon';
import { e4Format, e4Formats } from 'helpers/dates';

export const FeedbackObjectivesModal = ({ data, st }) => {
    if (!data) return <Loading />;
    const objectives = data.reduce((a, d) => (a.some(y => y.id === d.id) ? a : a.concat([d])), []);
    return (
        <div>
            {objectives.map(obj => {
                const feedback = data.filter(x => x.id === obj.id);
                const icon = type =>
                    type === 'approved'
                        ? 'text-success fa-thumbs-up'
                        : type === 'rejected'
                        ? 'text-danger fa-reply'
                        : 'text-info fa-comment';
                return (
                    <div key={`objective-${obj.id}`} className="flex flex-top mb10">
                        <div className="flex-grow">
                            <div className="mb5">
                                <span className="mr10 text-lg">
                                    <Link to={`/objectives/${obj.profile_Id}/objective/${obj.id}`}>{obj.name}</Link>
                                    <TaskIcon icons={obj.icons} />
                                </span>
                            </div>
                            {feedback.map((feedback, i) => (
                                <div key={`feedback-${i}-${obj.id}`} className="flex flex-top mb5">
                                    <i className={`fa ${icon(feedback.type)} mr10 mt10 text-lg`} />
                                    <div className="flex-grow">
                                        {feedback.other_Full_Name}
                                        {feedback.type === 'approved' ? (
                                            <div>{st('Feedback/Approved', e4Format(feedback.feedback, e4Formats.long))}</div>
                                        ) : feedback.type === 'rejected' ? (
                                            <div>{st('Feedback/Returned', e4Format(feedback.feedback, e4Formats.long))}</div>
                                        ) : (
                                            <div>
                                                {st('Feedback/Commented', e4Format(feedback.feedback, e4Formats.long))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default withRouter(FeedbackObjectivesModal);
